module.exports = __webpack_public_path__ + "img/real_land_3.6423c487.png";